export class RhinoError extends Error {
  constructor(code: RhinoErrorCode, message?: string, context?: RhinoErrorContext) {
    super(`RhinoError: (${code}) ${message ?? ''}`);

    this.code = code;
    this.context = context;

    // https://github.com/microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
    Object.setPrototypeOf(this, RhinoError.prototype);
  }

  code: RhinoErrorCode;
  context?: RhinoErrorContext;
}

export type RhinoErrorCode =
  | 'EXPIRED_KS'
  // Usually means that client tries to use ks token from another environment in development process
  | 'INVALID_KS'
  // Network request completed and server returned error 4xx/5xx
  | 'NETWORK_REQUEST_ERROR'
  // Network request "hard" fail(wasn't able to complete the request) - CORS, no internet, etc.
  | 'NETWORK_ERROR'
  // More context of the error in `context.nativeError`
  | 'NETWORK_API_ERROR'
  // Operation timeout
  | 'TIMEOUT'
  // non-recoverable configuration issue
  | 'CONFIGURATION'
  | '';

type RhinoErrorContext = Record<string, unknown>;
